export const COUNTRY_CODES: { code: string; label: string }[] = [
  { code: '+91', label: 'India (+91)' },
  { code: '+1', label: 'US / Canada (+1)' },
  { code: '+44', label: 'United Kingdom (+44)' },
  { code: '+971', label: 'UAE (+971)' },
  { code: '+966', label: 'Saudi Arabia (+966)' },
  { code: '+974', label: 'Qatar (+974)' },
  { code: '+965', label: 'Kuwait (+965)' },
  { code: '+968', label: 'Oman (+968)' },
  { code: '+973', label: 'Bahrain (+973)' },
  { code: '+65', label: 'Singapore (+65)' },
  { code: '+60', label: 'Malaysia (+60)' },
  { code: '+977', label: 'Nepal (+977)' },
  { code: '+880', label: 'Bangladesh (+880)' },
  { code: '+94', label: 'Sri Lanka (+94)' },
  { code: '+92', label: 'Pakistan (+92)' },
  { code: '+61', label: 'Australia (+61)' },
  { code: '+64', label: 'New Zealand (+64)' },
  { code: '+27', label: 'South Africa (+27)' },
  { code: '+234', label: 'Nigeria (+234)' },
  { code: '+254', label: 'Kenya (+254)' },
  { code: '+20', label: 'Egypt (+20)' },
  { code: '+49', label: 'Germany (+49)' },
  { code: '+33', label: 'France (+33)' },
  { code: '+34', label: 'Spain (+34)' },
  { code: '+39', label: 'Italy (+39)' },
  { code: '+31', label: 'Netherlands (+31)' },
  { code: '+353', label: 'Ireland (+353)' },
  { code: '+90', label: 'Turkey (+90)' },
  { code: '+7', label: 'Russia / Kazakhstan (+7)' },
  { code: '+55', label: 'Brazil (+55)' },
  { code: '+52', label: 'Mexico (+52)' },
  { code: '+62', label: 'Indonesia (+62)' },
  { code: '+63', label: 'Philippines (+63)' },
  { code: '+66', label: 'Thailand (+66)' },
  { code: '+84', label: 'Vietnam (+84)' },
  { code: '+81', label: 'Japan (+81)' },
  { code: '+82', label: 'South Korea (+82)' },
  { code: '+86', label: 'China (+86)' },
];

/** Split a stored E.164-ish number into the country code we know and the rest. */
export function splitPhone(
  phone: string | null | undefined,
  fallbackCode = '+91',
): { code: string; number: string } {
  const value = (phone || '').trim();
  if (!value.startsWith('+')) return { code: fallbackCode, number: value };
  const match = [...COUNTRY_CODES]
    .sort((a, b) => b.code.length - a.code.length)
    .find((c) => value.startsWith(c.code));
  return match
    ? { code: match.code, number: value.slice(match.code.length).trim() }
    : { code: fallbackCode, number: value };
}

export function joinPhone(code: string, number: string): string {
  const raw = number.trim();
  if (!raw) return '';
  if (raw.startsWith('+')) return `+${raw.replace(/\D/g, '')}`;
  return `${code}${raw.replace(/\D/g, '').replace(/^0+/, '')}`;
}

export function isPlausiblePhone(value: string): boolean {
  const raw = value.trim();
  if (/[^\d+\s().-]/.test(raw) || (raw.includes('+') && !/^\+[^+]*$/.test(raw))) return false;
  const digits = value.replace(/\D/g, '');
  return digits.length >= 7 && digits.length <= 15;
}

/** Manual privacy entries must match the international phone keys in call history. */
export function normalizeInternationalPhone(value: string): string | null {
  if (!value.trim().startsWith('+') || !isPlausiblePhone(value)) return null;
  const phone = `+${value.replace(/\D/g, '')}`;
  return /^\+[1-9]\d{6,14}$/.test(phone) ? phone : null;
}

/** Search input that is clearly a number → just its digits, else null. */
export function phoneQueryDigits(query: string): string | null {
  const q = query.trim();
  if (!q || /[a-z]/i.test(q)) return null;
  const digits = q.replace(/\D/g, '');
  return digits.length >= 3 ? digits : null;
}

export const telLink = (phone: string) => `tel:${phone.replace(/[^\d+]/g, '')}`;
export const whatsappLink = (phone: string) => `https://wa.me/${phone.replace(/\D/g, '')}`;
